import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { AttendanceHomeSearch } from "../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceHomeSearch";
import { AttendanceViewDetailInput } from "../../Controllers/Types/HeyTraderTypes/Attendances/New/AttendanceViewDetail";
import apiClient from "../apiClient";
import { baseURL } from "../ApiConstant";


// add attendancesEmployee
export const addAttendancesEmployeeNew = async (
  personal_info_id: number | null,
  work_type: 'Day' | 'Hour',
  daily_hours: number | null,
  daily_wage: number | null,
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-employee-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ personal_info_id, work_type, daily_hours, daily_wage }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update attendancesEmployee
export const updateAttendancesEmployeeNew = async (
  work_type: 'Day' | 'Hour',
  daily_hours: number | null,
  daily_wage: number | null,
  id: number | null
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/attendance-employee-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ daily_hours, daily_wage, work_type }),
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   active attendancesEmployee
export const activeAttendancesEmployeeNew = async (
  id: number | null
): Promise<CommonApiResponse> => {
  if (!id) {
    return { status: false, statusCode: 422, massage: "Employee id not found!" };
  }
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/attendance-employee-status-changed/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};


// service for atendance
//   Add attendances
export const addAttendancesNew = async (
  attendance_date: string | null,
  project_id: number | null,
  list: number[]
): Promise<CommonApiResponse> => {
  try {
    // prepare i
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-add-new`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ attendance_date, list, project_id }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   Update attendances
export const updateAttendancesNew = async (
  attendance_date: string | null,
  personal_info_id: number | null,
  project_id: number | null,
  work_hours: number | null,
  work_days: number | null
): Promise<CommonApiResponse> => {
  try {
    // prepare i
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-update-new`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ attendance_date, personal_info_id, project_id, work_hours, work_days }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete attendance
export const deleteAttendanceDataNew = async (
  personal_info_id: number,
  attendance_date: string
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/attendance-delete-new`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ personal_info_id, attendance_date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// attendance payment
//   Add attendances payment
export const addAttendanceStaffPaymentNew = async (
  date: string | null,
  expense_id: number | null,
  personal_info_id: number | null,
  payed_amount: number | null
): Promise<CommonApiResponse> => {
  try {
    // prepare i
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-payed-create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ date, expense_id, personal_info_id, payed_amount }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   update attendances payment
export const updateAttendanceStaffPaymentNew = async (
  date: string | null,
  expense_id: number | null,
  personal_info_id: number | null,
  payed_amount: number | null
): Promise<CommonApiResponse> => {
  try {
    // prepare i
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-payed-update`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ date, expense_id, personal_info_id, payed_amount }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete attendance
export const deleteAttendanceStaffPaymentNew = async (
  date: string,
  expense_id: number,
  personal_info_id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/attendance-payed-delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ date, expense_id, personal_info_id }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// GET REQUESTES

// Expense category
export const getAtendanceExpenseCategory = async () => {
  try {
    const response = await apiClient.get(`/api/attendance-expense-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// attendance project list
export const getAttendanceProjectListServiceNew = async () => {
  try {
    const response = await apiClient.get(`/api/attendance-project-list`);
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get attendance employee list
export const getAttendanceEmployeeListServiceNew = async (date?: string | null) => {
  try {
    const endpoint = date
      ? `/api/attendance-employee-list/${date}`
      : `/api/attendance-employee-list`;

    const response = await apiClient.get(endpoint);

    if (response.status === 200) {
      return { status: true, body: response.data };
    }

    return { status: false, error: "Failed to fetch data." };

  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// attendance Home data
export const getAtendanceHomeDataNew = async (input: AttendanceHomeSearch) => {
  try {
    const response = await apiClient.post(`/api/attendance-home-data-new`, input);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};


// attendance Staff view detail
export const getAttendanceViewDetail = async (input: AttendanceViewDetailInput) => {
  try {
    const response = await apiClient.post(`/api/attendance-home-data/staff-view-detail`, input);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};